// Consumer Duty: fair value: the routes and the sidebar rows of `wealth.compliance.consumer-duty.fair-value` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.consumer-duty.fair-value',
    routes: [
        {
            frontend: 'comply',
            path: 'fair-value',
            lazy: () => import('@/pages/comply/fair-value/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'fair-value',
            label: 'Fair Value',
            href: '/comply/fair-value',
            icon: 'Scale',
            group: 'consumer-duty',
            order: 240,
            wip: true,
        },
    ],
});
